import React from "react";
import createReactClass from "create-react-class";

import Loader from "../loader";

export default createReactClass({
  displayName: "Root",
  getDefaultProps() {
    return {
      message: null,
      dummyProgressShown: false,
    }
  },
  getInitialState() {
    return {
      isActive: false,
      fadeClassName: "modal-view-fade-in",
      scrollPos: 0,
      message: this.props.message,
      dummyProgressShown: this.props.dummyProgressShown,
    };
  },
  componentDidMount() {
    this._handle = 0;
  },
  componentWillUnmount() {
    clearTimeout(this._handle);
  },
  openModal() {
    var scrollPos = window.pageYOffset;
    var marginLeft =
      (window.innerWidth - $(".royal_preloader .container").outerWidth()) / 2;
    var width = window.innerWidth > 767 ? "" : "100%";
    $(document.body).css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
      width: width,
    });
    this.setState({
      fadeClassName: "modal-view-fade-in",
      isActive: true,
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $(document.body).css({
      position: "relative",
      marginTop: "0",
      marginLeft: "0",
      width: "",
    });
    // $(window).scrollTop(this.state.scrollPos);
    this.setState({
      fadeClassName: "modal-view-fade-out",
    });
    this._handle = setTimeout(
      function() {
        this.setState({
          isActive: false,
        });
      }.bind(this),
      300
    );
  },
  handleApproveButton() {
    this.props.approveFunc();
    this.closeModal();
  },
  handleRejectButton() {
    if (this.props.rejectFunc != undefined) {
      this.props.rejectFunc();
    }
    this.closeModal();
  },
  render() {
    if (!this.state.isActive) {
      return null;
    }
    return (
      <div className="modal-view">
        <div className={this.state.fadeClassName}>
          <div className="modal-view-overAll">
            <div className="modal-view-overlay" />
            <div className="modal-view-dialog">
              <div className="modal-view-content">
                <div className="modal-view-body">
                  {this.state.message && <p>{this.state.message}</p>}
                  <Loader isActive={true} />
                  {this.state.dummyProgressShown && (
                    <div style={{position: 'relative', width: '100%', height: '6px', background: '#d9d9d9', borderRadius: '3px', overflow: 'hidden'}}>
                      <div style={{position: 'absolute', top: 0, bottom: 0, left: 0, width: '90%', background: '#FF6467', animation: 'progress-dummy 60s normal', animationFillMode: 'forwards'}}></div>
                    </div>
                  )}
                </div>
                <div className="modal-view-footer" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
